import type { PriceListUerRowData } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useMemo } from 'react';

export interface IUnitCostWithOtherCellRendererComponent extends ICellRendererParams<PriceListUerRowData> {
    constructionTypeId: number;
}

export const UnitCostWithOtherCellRendererComponent: React.FC<IUnitCostWithOtherCellRendererComponent> = (props) => {
    const { constructionTypeId, data } = props;

    const unitCostWithOther = useMemo(
        () =>
            formatNumberToRu(
                data?.currentPrices.find((price) => price.constructionTypeId === constructionTypeId)
                    ?.unitCostWithOther || 0,
                2,
            ),
        [constructionTypeId, data?.currentPrices],
    );

    return <div>{unitCostWithOther}</div>;
};

UnitCostWithOtherCellRendererComponent.displayName = 'UnitCostWithOtherCellRendererComponent';
